<template>
  <div id="app">
    <div class="body">

      <CurrentDay v-if="activeItem==='today'"></CurrentDay>
      <HistoryRecord v-if="activeItem==='history'"></HistoryRecord>
      <UserProfile v-if="activeItem==='profile'"></UserProfile>
    </div>

    <div class="footer" @click="triggerHiddenMenu">
      <div class="item" :active="activeItem==='today'" @click="activeItem='today'">
        <div class="icon"><i class="el-icon-medal"></i></div>今天</div>
      <div class="item" :active="activeItem==='history'" @click="activeItem='history'">
        <div class="icon">
          <i class="el-icon-s-order"></i>
        </div>回顾</div>
      <div class="item" v-if="showHiddenMenu" :active="activeItem==='profile'" @click="activeItem='profile'">
        <div class="icon">
          <i class="el-icon-user"></i>
        </div>我</div>
    </div>
  </div>
</template>

<script>
import CurrentDay from "@/components/CurrentDay";
import HistoryRecord from "@/components/HistoryRecord";
import {randomString,genCounter} from "@/util/id"
import VueCookies from "vue-cookies"
import UserProfile from "@/components/UserProfile";

export default {
  name: 'App',
  components: {
    UserProfile,
    HistoryRecord,
    CurrentDay,
  },
  data(){
    return {
      activeItem:'today',
      hiddenMenuCounter:{},
      showHiddenMenu:false
    }
  },
  created() {
    VueCookies.set("score_record_user", this.getID())
    this.hiddenMenuCounter=genCounter(5,2)
  },
  methods:{
    getID(){
      if(localStorage.id){
        return localStorage.id
      }else{
        let id=randomString()
        localStorage.id=id
        return id
      }
    },
    triggerHiddenMenu(){
      if(this.hiddenMenuCounter.ok()){
        this.showHiddenMenu=true
        return
      }
      this.hiddenMenuCounter.add()
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  width: 100vw;
  height: 100vh;
}
.body{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.footer{
  width: 100%;
  height: 50px;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
  background-color: #eeeeeeaa;
  .item{
    width: 40%;
    text-align: center;
    &[active=true]{
      color: #409EFF;
    }
    .icon{
      margin-bottom: -3px;
    }
  }
}
</style>
